export enum AddClientErrorTypes {
    VALIDATION_ERROR = "validation-error",
    REFERRAL_ALREADY_ACCEPTED = "referral-accepted-error",
    TOKEN_NOT_VALID = "token-invalid-error",
    REFERRAL_VOID = "referral-void",
    REFERRAL_EXPIRED = "referral-expired"
}

export const TEXT_FIELD_ID = "token-input"
